import { styled, Variants } from "@nju/css";

export const Circle = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "$round",
  variants: {
    tone: {
      expressive: {
        backgroundColor: "$black",
      },
      discreet: {
        backgroundColor: "$white",
      },
      accent: {
        backgroundColor: "$cerulean",
      },
      alternative: {
        backgroundColor: "$geyser",
      },
      discreetGrey: {
        backgroundColor: "$porcelain",
      },
      daintree: {
        backgroundColor: "$daintree",
      },
      none: {
        backgroundColor: "none",
      },
    },
    padding: {
      none: {
        padding: "0px",
      },
      xs: {
        padding: "3px",
      },
      sm: {
        padding: "$5",
      },
      m: {
        padding: "$10",
      },
      l: {
        padding: "$15",
      },
    },
  },
  defaultVariants: { padding: "m" },
});

export type CircleProps = Variants<typeof Circle>;
